"use client";

import { FC } from "react";

import useFeatureFlag from "apps/website/hooks/useFeatureFlag";

import {
  isKlaviyoFormPartOfExperiment,
  isModalKlaviyoForm,
  isSectionKlaviyoForm,
  TStoryBlokKlaviyoForm,
} from "./SectionKlaviyoForm.types";
import SectionKlaviyoFormModal from "./SectionKlaviyoFormModal/SectionKlaviyoFormModal";
import SectionKlaviyoFormSection from "./SectionKlaviyoFormSection/SectionKlaviyoFormSection";

const KlaviyoForm: FC<TStoryBlokKlaviyoForm> = (props) => (
  <>
    { isModalKlaviyoForm(props) ? <SectionKlaviyoFormModal {...props} /> : null }
    { isSectionKlaviyoForm(props) ? <SectionKlaviyoFormSection { ...props } /> : null }
  </>
);

const SectionKlaviyoForm: FC<TStoryBlokKlaviyoForm> = (props) => {
  const { isFeatureFlagActive } = useFeatureFlag({
    featureFlagId: props.featureFlagId,
    featureFlagValue: props.featureFlagValue,
    options: {
      defaultValue: !isKlaviyoFormPartOfExperiment(props),
    },
  });

  return (
    <div data-component={SectionKlaviyoForm.name}>
      { isFeatureFlagActive ? (
        <KlaviyoForm {...props} />
      ) : null }
    </div>
  );
};

export default SectionKlaviyoForm;
